// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-promo-course__p:before{position:absolute;top:-0.5rem;left:0px;display:block;height:3rem;width:3rem;border-radius:9999px;--tw-bg-opacity:1;background-color:rgb(255 222 0 / var(--tw-bg-opacity));content:\"\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
